import { Injectable } from "@angular/core";
import { AccountAppDeviceSignalHandlerService } from "../handlers/account-app-device-signal-handler.service";
import { AccountSignalCategoriesHandlerService } from "../handlers/account-signal-categories-handler.service";
import { SignalTemplateHandlerService } from "../handlers/signal-template-handler.service";

export interface TemplateDTO {
  account_app_id: number;
  allow_quicksignal?: boolean;
  background?: any;
  deleted_at?: Date;
  footer?: any;
  has_feedback?: boolean;
  id?: string;
  logo?: any;
  name: string;
  restored_at?: Date;
  thumbnail?: any;
  feedback_color?: string;
}

@Injectable({
  providedIn: "root",
})
export class SignalsService {
  constructor(
    private signalTemplateHandlerService: SignalTemplateHandlerService,
    private accountSignalCategoriesHandlerService: AccountSignalCategoriesHandlerService,
    private accountAppDeviceSignalHandlingService: AccountAppDeviceSignalHandlerService,
  ) {}

  // LIST
  getSignalTemplates(
    masterAccountID: number,
    queryParams?: { page?: number; perPage?: number },
  ) {
    return this.signalTemplateHandlerService.signalTemplatesGet(
      masterAccountID,
      queryParams,
    );
  }

  getSignalTemplate(masterAccountID: number, templateID: number) {
    return this.signalTemplateHandlerService.signalTemplatGet(
      masterAccountID,
      templateID,
    );
  }

  getSignalPreview(masterAccountID: number, previewDTO: any) {
    return this.signalTemplateHandlerService.signalTemplatePreviewPost(
      masterAccountID,
      previewDTO,
    );
  }

  getSignalCategories(accountID: number) {
    return this.accountSignalCategoriesHandlerService.accountSignalCategoriesGet(
      accountID,
    );
  }

  getSignalCategory(accountID: number, categoryID: number) {
    return this.accountSignalCategoriesHandlerService.accountSignalCategoryGet(
      accountID,
      categoryID,
    );
  }

  createSignalCategory(accountID: number, signalCategoryDTO: any) {
    return this.accountSignalCategoriesHandlerService.accountSignalCategoryPost(
      accountID,
      signalCategoryDTO,
    );
  }

  updateSignalCategory(accountID: number, signalCategoryDTO: any) {
    return this.accountSignalCategoriesHandlerService.accountSignalCategoryPut(
      accountID,
      signalCategoryDTO,
    );
  }

  deleteSignalCategory(masterAccountID: number, categoryID: number) {
    return this.accountSignalCategoriesHandlerService.accountSignalCategoryDelete(
      masterAccountID,
      categoryID,
    );
  }

  deleteSignalTemplate(masterAccountID: number, templateID: string) {
    return this.signalTemplateHandlerService.signalTemplateDelete(
      masterAccountID,
      templateID,
    );
  }

  createSignalTemplate(masterAccountID: number, template: TemplateDTO) {
    return this.signalTemplateHandlerService.signalTemplatePost(
      masterAccountID,
      template,
    );
  }

  updateSignalTemplate(
    masterAccountID: number,
    templateID: string,
    template: TemplateDTO,
  ) {
    return this.signalTemplateHandlerService.signalTemplatePut(
      masterAccountID,
      templateID,
      template,
    );
  }

  getRedemptionsReport(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      facility_id?: number[];
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
    },
  ) {
    return this.accountAppDeviceSignalHandlingService.redemptionsGet(
      masterAccountID,
      accountAppID,
      queryParams
    );
  }

}
